import { Component } from '@angular/core';

@Component({
  selector: 'pyxis-report-request-error',
  templateUrl: './report-request-error.component.html',
  styleUrls: ['./report-request-error.component.scss']
})
export class ReportRequestErrorComponent {
}
